var _listContenuti;
var _listAnagrafiche;

//function InitPagineContenutiLista() {
//    var options = {
//        valueNames: [
//            "id",
//            { data: ["tipo"] },
//            "nome",
//            "descrizione",
//            "permalink",
//            "inserimento",
//            "modifica",
//            { data: ["stato"] }
//        ],
//        page: 9,
//        pagination: true
//    };

//    _listContenuti = new List('divcontenutisito', options);

//    _listContenuti.on('updated', function (list) {
//        if (list.matchingItems.length > 0) {
//            $('.noresult').hide()
//        } else {
//            $('.noresult').show()
//        }
//    });
//}

//$(document).on("click", "[data-int-tipo]", function () {
//    $('[data-int-tipo="all"]').removeClass("border card-border-dark");
//    $('[data-int-tipo="pagina"]').removeClass("border card-border-info");
//    $('[data-int-tipo="blog"]').removeClass("border card-border-warning");
//    $('[data-int-tipo="online"]').removeClass("border card-border-success");
//    $('[data-int-tipo="bozza"]').removeClass("border card-border-danger");

//    var _filtro = $(this).data("int-tipo");

//    switch (_filtro) {
//        case "all":
//            $(this).addClass("border card-border-dark");
//            break;
//        case "pagina":
//            $(this).addClass("border card-border-info");
//            break;
//        case "blog":
//            $(this).addClass("border card-border-warning");
//            break;
//        case "online":
//            $(this).addClass("border card-border-success");
//            break;
//        case "bozza":
//            $(this).addClass("border card-border-danger");
//            break;
//    }

//    _listContenuti.filter(function (item) {
//        if (_filtro == "all")
//            return true;
//        else if (_filtro == "bozza" || _filtro == "online")
//            return (item.values().stato == _filtro);
//        else
//            return (item.values().tipo == _filtro);
//    });
//});


//$(document).on("click", "[data-list-url]", function (obj) {
//    obj.preventDefault();
//    var _url = $(this).data("list-url");

//    Controlli.Utility.DestroyControl(Controlli.Utility.BodyName);
//    Controlli.Ajax.AjaxLoadingHTML(_url);
//    $(document).on(Controlli.Ajax.AjaxLoadingHTML_Done, () => Controlli.Ajax.UpdateURLAjax());
//});

//$(document).on("click", "[data-int-folderid]", function () {
//    var _folderid = $(this).data("int-folderid");

//    var _newHtml;

//    if (_folderid != null)
//        _newHtml = Controlli.Ajax.AjaxGetHTML(UrlFilePickerLista, { Folder: _folderid });
//    else
//        _newHtml = Controlli.Ajax.AjaxGetHTML(UrlFilePickerLista);

//    $("#folder-list").html(_newHtml);
//});

//$(document).on("click", "[data-int-imageid]", function () {
//    $("[data-int-imageid]").removeClass("border border-3 border-info");
//    $(this).addClass("border border-3 border-info")

//    var _file = $(this).data("int-imageid");

//    var _newHtml;

//    if (_file != null)
//        _newHtml = Controlli.Ajax.AjaxGetHTML(UrlFilePickerDettagli, { Media: _file });
//    else
//        _newHtml = Controlli.Ajax.AjaxGetHTML(UrlFilePickerDettagli);

//    $("#file-overview").html(_newHtml);
//});


//function InitImageUploadControls() {
//    (<any>$("#input-upload-img-filepicker")).filepond({
//        name: "imguploader",
//        required: false,
//        allowImagePreview: false,
//        allowMultiple: true,
//        allowReorder: false,
//        allowRevert: false,
//        credits: null,
//        maxFiles: 5,
//        allowFileSizeValidation: true,
//        minFileSize: "1KB",
//        maxFileSize: "4MB",
//        labelIdle: 'Trascina o Sfoglia',
//        server: {
//            process: UrlUploadImgCarica
//        }
//    });
//}

//$(document).on("click", "[data-int-imgid]", function () {
//    let _id = $(this).data("int-imgid");

//    var _imgHtml = Controlli.Ajax.AjaxGetHTML(UrlFilePickerSelectImg, { id: _id });

//    tinymce.activeEditor.execCommand('mceInsertContent', false, _imgHtml);

//    Controlli.FormAside.Hide();
//});